"use strict";

angular.module("core")
.component("search", {
    bindings: {
        "isMainSearch": "<?",
        "eventName": "@?"
    },
    templateUrl: require("./search.component.html"),
    controller: function($scope, $stateParams, StateExtensionService) {
        this.search = function() {
            var eventName = this.eventName ? this.eventName: "queryListing";
            $scope.$emit(eventName, {search: this.searchTerm});
            if (this.isMainSearch) {
                StateExtensionService.updateUrlParams({search: this.searchTerm});
            }
        };

        this.searchTerm = $stateParams.search;

        this.reset = function() {
            this.searchTerm = undefined;
            this.search();
        };
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/search/search.component.js
// module id = 580
// module chunks = 0